import { NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from '../../lib/routes';
import { Brand } from './CenteredCardLayout';
import './layout.css';

const NAV_ITEMS = [
  { to: ROUTES.account, label: 'Tổng quan', end: true },
  { to: ROUTES.profile, label: 'Hồ sơ', end: false },
  { to: ROUTES.connections, label: 'Kết nối', end: false },
  { to: ROUTES.security, label: 'Bảo mật', end: false },
];

/** App shell with header + navigation for /account/* routes (spec §7.1). */
export function AppShell() {
  return (
    <div className="shell">
      <a className="skip-link" href="#main">
        Bỏ qua đến nội dung chính
      </a>
      <header className="shell__header">
        <div className="shell__header-inner">
          <Brand />
          <nav className="shell__nav" aria-label="Tài khoản">
            {NAV_ITEMS.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end}>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="shell__main" id="main">
        <Outlet />
      </main>
    </div>
  );
}
